// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__psduJ","modal":"styles_modal__ulIpc","closeCross":"styles_closeCross__SUjFq"};